/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CompositeSearchEnhancedFilterConditionType } from './CompositeSearchEnhancedFilterConditionType';

export type CompositeSearchEnhancedFilterTag = {
    filterType: CompositeSearchEnhancedFilterTag.filterType;
    conditionType: CompositeSearchEnhancedFilterConditionType;
    value: Array<number>;
};

export namespace CompositeSearchEnhancedFilterTag {

    export enum filterType {
        TAG = 'tag',
    }


}

